import { requestApi } from './Api';

export const getFormPackets = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/settings/forms/form_packet/get_all',
    params
  });

export const createForm = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/settings/forms/upsert',
    params
  });

export const getDraftedForms = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/settings/forms/drafts',
    params
  });

export const getForms = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/settings/forms/get_all',
    params
  });

export const deleteForm = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/settings/forms/delete',
    params
  });
